import { TooltipWebV3 } from '@components/TaskList/TooltipWebV3';
import React from 'react';

import { Text } from '@components/Restyle';

export const UPGRADE_PAYWALL_TOOLTIP_TITLE = 'Upgrade to unlock team features';

type UpgradePaywallTooltipProps = {
  /** When true, wraps children with tooltip; when false, renders children only */
  show: boolean;
  children: React.ReactNode;
};

/**
 * Centralized tooltip for CTAs that trigger the team paywall.
 * Use on web for any button/link that opens the paywall modal when the team is expired.
 * Title and placement are fixed here for consistent UX and easy future updates.
 */
export const UpgradePaywallTooltip: React.FC<UpgradePaywallTooltipProps> = ({
  show,
  children,
}) => {
  if (!show) {
    return <>{children}</>;
  }

  return (
    <TooltipWebV3
      title={
        <Text variant='labelSmall' color='white'>
          {UPGRADE_PAYWALL_TOOLTIP_TITLE}
        </Text>
      }
      placement='bottom-end'
      marginOffset={8}
      variant='dark'>
      {children}
    </TooltipWebV3>
  );
};
